import { vcpodeHttp } from '@/http';
import { serialize } from './utils';

const getSectors = (companyId, data = {}) =>
	vcpodeHttp.get(`v2/company/${companyId}/sectors${serialize(data)}`);

const createSector = (companyId, data) =>
	vcpodeHttp.post(`v2/company/${companyId}/sectors`, data);

const updateSector = (companyId, sectorId, data) =>
	vcpodeHttp.patch(`v2/company/${companyId}/sectors/${sectorId}`, data);

const transferEmployees = (companyId, sectorId, targetSectorId) =>
	vcpodeHttp.post(`v2/company/${companyId}/sectors/${sectorId}/transfer-employees`, { targetSectorId });

const setBeneficiarySector = (companyId, beneficiaryId, sectorId) =>
	vcpodeHttp.patch(`v2/company/${companyId}/beneficiaries/${beneficiaryId}`, { sectorId });

export const sectors = {
	getSectors,
	createSector,
	updateSector,
	transferEmployees,
	setBeneficiarySector,
};
